import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const CancelIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        className="filled"
        d="M 49.063071,43.360385 49.90431,42.519357 49.063071,41.678121 35.384915,27.999989 49.063071,14.321652 49.90431,13.480415 49.063071,12.639385 43.360592,6.936772 42.519355,6.0956594 41.678323,6.936772 27.99996,20.615047 14.321599,6.936772 13.480568,6.0956594 12.639412,6.936772 6.9367884,12.639385 6.0956536,13.480415 6.9367884,14.321652 20.615007,27.999989 6.9367884,41.678121 l -0.8411348,0.841236 0.8411348,0.841028 5.7026236,5.702676 0.841156,0.841236 0.841031,-0.841236 13.678361,-13.678338 13.678363,13.678338 0.841032,0.841236 0.841237,-0.841236 z"
      />
    </SvgIcon>
  );
};

export default CancelIcon;
